var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container visitReportSpDetail" },
    [
      _c("div", { staticClass: "searchBox" }, [
        _c(
          "div",
          { staticClass: "searchBox_top" },
          [
            _vm.showButton
              ? [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.Spmsv - _vm.reportSave,
                          expression: "Spmsv-reportSave",
                        },
                      ],
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.saveVisit("queryCondition")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("visitPlan.draftSave")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.Spmsv - _vm.reportSubmit,
                          expression: "Spmsv-reportSubmit",
                        },
                      ],
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitVisitPlan("queryCondition")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.submit")))]
                  ),
                ]
              : _vm._e(),
            _c(
              "el-button",
              {
                attrs: { size: "mini", type: "primary" },
                on: { click: _vm.goBack },
              },
              [_vm._v(_vm._s(_vm.$t("common.close")))]
            ),
            _vm.showButton
              ? [
                  _c("br"),
                  _c(
                    "label",
                    { staticStyle: { "font-size": "12px", color: "#F56C6C" } },
                    [_vm._v(_vm._s(_vm.$t("visitPlan.operationTips")))]
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [_c("span", [_vm._v("MSV Basic Info")])]
          ),
          _c(
            "el-form",
            {
              ref: "queryCondition",
              attrs: {
                model: _vm.queryCondition,
                rules: _vm.queryConditionRules,
                inline: "",
                "label-width": "255px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "MSV 单据编号", prop: "msvNo" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.queryCondition.msvNo,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.queryCondition,
                          "msvNo",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "queryCondition.msvNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("visitPlan.Year"), prop: "year" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.queryCondition.year,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryCondition, "year", $$v)
                      },
                      expression: "queryCondition.year",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("visitPlan.Type"), prop: "type" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.queryCondition.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryCondition, "type", $$v)
                        },
                        expression: "queryCondition.type",
                      },
                    },
                    _vm._l(_vm.typeList, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.chineseValue, value: item.code },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("visitPlan.Category"),
                    prop: "category",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.queryCondition.category,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryCondition, "category", $$v)
                        },
                        expression: "queryCondition.category",
                      },
                    },
                    [_c("el-option", { attrs: { value: "1" } })],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("visitPlan.SupplierFacility"),
                    prop: "tmSupplierId",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.queryCondition.plantName,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryCondition, "plantName", $$v)
                      },
                      expression: "queryCondition.plantName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("visitPlan.ReportBy"),
                    prop: "createBy",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.createBy,
                      callback: function ($$v) {
                        _vm.createBy = $$v
                      },
                      expression: "createBy",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("visitPlan.CreateDate"),
                    prop: "dataArr",
                  },
                },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "date",
                      placeholder: "选择日期",
                      disabled: "",
                    },
                    model: {
                      value: _vm.queryCondition.createDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryCondition, "createDate", $$v)
                      },
                      expression: "queryCondition.createDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Visit Type", prop: "visitType" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.queryCondition.visitType,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryCondition, "visitType", $$v)
                        },
                        expression: "queryCondition.visitType",
                      },
                    },
                    _vm._l(_vm.visitTypeList, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.chineseValue, value: item.code },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Report to（Supplier）",
                    prop: "supplierEmail",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { disabled: "", type: "textarea", rows: 3 },
                    model: {
                      value: _vm.queryCondition.supplierEmail,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryCondition, "supplierEmail", $$v)
                      },
                      expression: "queryCondition.supplierEmail",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Report to（McD）", prop: "mcdEmail" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "", type: "textarea", rows: 3 },
                    model: {
                      value: _vm.queryCondition.mcdEmail,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryCondition, "mcdEmail", $$v)
                      },
                      expression: "queryCondition.mcdEmail",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Attendees Supplier",
                    prop: "attendeesSupplier",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { disabled: "", type: "textarea", rows: 3 },
                    model: {
                      value: _vm.queryCondition.attendeesSupplier,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryCondition, "attendeesSupplier", $$v)
                      },
                      expression: "queryCondition.attendeesSupplier",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Attendees McDonald’s(& On behalf)",
                    prop: "attendeesMcd",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { disabled: "", type: "textarea", rows: 3 },
                    model: {
                      value: _vm.queryCondition.attendeesMcd,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryCondition, "attendeesMcd", $$v)
                      },
                      expression: "queryCondition.attendeesMcd",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Mgt. recap", prop: "mgtRecap" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.queryCondition.mgtRecap,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryCondition, "mgtRecap", $$v)
                        },
                        expression: "queryCondition.mgtRecap",
                      },
                    },
                    _vm._l(_vm.mgtRecapList, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.chineseValue, value: item.code },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "MSV Result", prop: "msvResult" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.queryCondition.msvResult,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryCondition, "msvResult", $$v)
                        },
                        expression: "queryCondition.msvResult",
                      },
                    },
                    _vm._l(_vm.msvResultList, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.chineseValue, value: item.code },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c("el-form-item", {
                    attrs: { label: "On-site observations Number" },
                  }),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "highScoreClass",
                      attrs: { label: "High Risk", prop: "highScore" },
                    },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", type: "number", disabled: "" },
                        model: {
                          value: _vm.queryCondition.highScore,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryCondition, "highScore", $$v)
                          },
                          expression: "queryCondition.highScore",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "ScoreClass",
                      attrs: { label: "Medium Risk", prop: "mediumScore" },
                    },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", type: "number", disabled: "" },
                        model: {
                          value: _vm.queryCondition.mediumScore,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryCondition, "mediumScore", $$v)
                          },
                          expression: "queryCondition.mediumScore",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "ScoreClass",
                      attrs: { label: "Low Risk", prop: "lowScore" },
                    },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", type: "number", disabled: "" },
                        model: {
                          value: _vm.queryCondition.lowScore,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryCondition, "lowScore", $$v)
                          },
                          expression: "queryCondition.lowScore",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "拜访日期", prop: "dataArr" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "range-separator": _vm.$t("common.to"),
                      "start-placeholder": _vm.$t("common.startDate"),
                      "end-placeholder": _vm.$t("common.endDate"),
                      disabled: "",
                    },
                    model: {
                      value: _vm.dataArr,
                      callback: function ($$v) {
                        _vm.dataArr = $$v
                      },
                      expression: "dataArr",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              ref: "tableList",
              staticClass: "purposeList",
              attrs: { data: _vm.tableList, border: "", fit: "" },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "50" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "visitPurpose",
                  label: "拜访目的",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-autocomplete", {
                          staticClass: "inline-input",
                          attrs: {
                            disabled: "",
                            "fetch-suggestions": _vm.querySearch,
                            placeholder: "请输入内容",
                          },
                          model: {
                            value: scope.row.visitPurpose,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "visitPurpose", $$v)
                            },
                            expression: "scope.row.visitPurpose",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "CQS附件", name: "first" } },
            [
              _c(
                "el-table",
                {
                  staticClass: "table",
                  attrs: {
                    data: _vm.fileList,
                    border: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "",
                      prop: "documentName",
                      label: _vm.$t("common.file"),
                      "min-width": "130px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-link",
                              {
                                attrs: { type: "primary" },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.downloadFileFDP(scope.row)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(scope.row.documentName) + " ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "供应商附件", name: "second" } },
            [
              _c(
                "el-table",
                {
                  staticClass: "table",
                  attrs: {
                    data: _vm.fileList2,
                    border: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "",
                      prop: "documentName",
                      label: _vm.$t("common.file"),
                      "min-width": "130px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-link",
                              {
                                attrs: { type: "primary" },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.downloadFile(scope.row)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(scope.row.documentName) + " ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "",
                      prop: "userName",
                      label: _vm.$t("common.createBy"),
                      "min-width": "130px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "",
                      prop: "createDate",
                      label: _vm.$t("common.createDate"),
                      "min-width": "130px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("dateFormatFilter")(
                                    scope.row.createDate,
                                    "YYYY-MM-DD HH:mm"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm.isdeleteFile
                    ? _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          prop: "tmDocumentId",
                          "min-width": "130px",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-link",
                                    {
                                      attrs: { type: "primary" },
                                      nativeOn: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.deleteFile(
                                            scope.row.tmDocumentId,
                                            scope.$index,
                                            _vm.fileList2,
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("common.del")))]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4006188956
                        ),
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm.showButton
                ? [
                    _c(
                      "div",
                      { staticClass: "toolsBox" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.submitUpload()
                              },
                            },
                          },
                          [_vm._v("上传到服务器")]
                        ),
                      ],
                      1
                    ),
                    _c("el-divider"),
                    _c("div", { staticClass: "block" }, [
                      _c("span", { staticClass: "tip" }, [
                        _vm._v("上传文件说明:"),
                      ]),
                    ]),
                    _c("div", { staticClass: "tipText" }, [
                      _c("span", [
                        _vm._v("* 请填写附件对应的发现项内容描述！"),
                      ]),
                      _c("span", [
                        _vm._v(
                          "*上传文件支持PDF，Excel，Word，.JPG，.PNG, .ZIP, .7Z"
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "uploadBox" },
                      [
                        _c(
                          "el-upload",
                          {
                            ref: "upload",
                            staticStyle: { float: "left" },
                            attrs: {
                              action: "upload",
                              "http-request": _vm.uploadConfirm,
                              multiple: "",
                              "before-remove": _vm.beforeRemove,
                              "on-remove": _vm.removeFile,
                              "list-type": "picture-card",
                              "file-list": _vm.uploadFileList,
                              name: "file",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "file",
                                  fn: function ({ file }) {
                                    return _c(
                                      "div",
                                      { staticStyle: { height: "100%" } },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "fileName" },
                                          [_vm._v(_vm._s(file.name))]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "el-upload-list__item-actions",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "el-upload-list__item-delete",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.removeFile(file)
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-delete",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: file.docComments,
                                              expression: "file.docComments",
                                            },
                                          ],
                                          staticClass: "miaoshu",
                                          attrs: {
                                            type: "text",
                                            placeholder: "描述",
                                          },
                                          domProps: { value: file.docComments },
                                          on: {
                                            input: [
                                              function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  file,
                                                  "docComments",
                                                  $event.target.value
                                                )
                                              },
                                              function ($event) {
                                                return _vm.miaoahuChange(file)
                                              },
                                            ],
                                          },
                                        }),
                                      ]
                                    )
                                  },
                                },
                              ],
                              null,
                              false,
                              774029332
                            ),
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  slot: "trigger",
                                  size: "small",
                                  type: "primary",
                                },
                                slot: "trigger",
                              },
                              [_vm._v(_vm._s(_vm.$t("common.selectFile")))]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }